import { createFileRoute } from '@tanstack/react-router';

import { VideoSetupPage } from './-components/VideoSetupPage';

export const Route = createFileRoute('/_authenticated/externalContent/videos/new')({
    component: VideoSetupPage,
});
